// extracted by mini-css-extract-plugin
export default {"root":"ECvtyr2m_1NDX1jRAGUP"};